<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { useAuthenticationStore } from '@/application/whitelabel/authentication/store';
import { useOnboardingStore } from '../store';

@Component
export default class RecipesStep extends Vue {

  readonly store = useOnboardingStore();
  readonly authenticationStore = useAuthenticationStore();

  submitClicked(): void {
    this.$emit('submitConfirmed');
  }

  skipClicked(): void {
    this.$emit('skipConfirmed');
  }

}
</script>
<template>
<div class="modules">
  <v-card-text class="pb-0">
    <h2>Rezepte</h2>

    <v-row
      v-if="store.featureExamples.recipes.length > 0"
      class="recipe-list mt-4 mb-4 mb-md-2"
    >
      <v-col
        cols="12"
        md="6"
        lg="4"
        v-for="(recipe, index) in store.featureExamples.recipes"
        :key="recipe.recipeId"
      >

        <v-row
          class="no-gutters recipe"
          :class="{ 'mb-4': index !== store.featureExamples.recipes.length - 1 }"
        >
          <v-col cols="4">
            <v-card outlined class="overflow-hidden">
              <div class="blur-hash-image-container">
                <blur-hash-image
                  :hash="recipe.heroImage.hash"
                  :src="recipe.heroImage.url"
                  :alt="recipe.name"
                  :width="20"
                  :height="Math.floor(20 / recipe.heroImage.aspectRatio)"
                />
                <span class="total-time">
                {{ recipe.totalTimeInMinutes }}min
              </span>
              </div>
            </v-card>
          </v-col>
          <v-col cols="8">
            <div class="recipe-info">
              <strong class="recipe-title">{{ recipe.name }}</strong>
              <span v-if="recipe.subTitle" class="d-block">{{ recipe.subTitle }}</span>
              <span class="d-block action-link">Rezept anzeigen</span>
            </div>
          </v-col>
        </v-row>

      </v-col>

    </v-row>

    <p>
      In der Rubrik "Rezepte" findest du eine Liste von schmackhaften Gerichten zum Nachkochen inkl. Tipps von Experten.
    </p>
    <p>
      Klasse vor Masse: Wir fokussieren uns an dieser Stelle auf eine handverlesene Sammlung an köstlichen und gesunden Kochideen.
    </p>

  </v-card-text>

  <v-divider />
  <v-card-actions>
    <v-spacer />
    <a-cancel-action-button @click="skipClicked">
      Einführung überspringen
    </a-cancel-action-button>
    <a-trigger-primary-process-button @click="submitClicked">
      Weiter
    </a-trigger-primary-process-button>
  </v-card-actions>

</div>
</template>
<style lang="sass" scoped>
.recipe-list
  font-size: 0.875rem

  .recipe
    cursor: default

    .blur-hash-image-container
      position: relative

      .total-time
        position: absolute
        bottom: 0
        right: 0
        color: var(--color-white)
        background: var(--color-brand)
        padding: 2px 0.5rem
        font-weight: 600
        border-top-left-radius: 0.25rem

    .recipe-info
      padding: 0 0 0 0.75rem
      line-height: 1.15

      strong.recipe-title
        font-weight: 700
        font-family: Montserrat, sans-serif
        color: var(--color-grey-2)
        display: block
        margin-top: 0.25rem
        margin-bottom: 0.25rem

      span::v-deep
        font-size: 0.875rem

        strong
          font-weight: 600

  .action-link
    color: var(--color-brand)
    font-weight: 600
    margin-top: 0.25rem
</style>
